<template>
	<div
		v-if="onePs.technologies"
		v-on:click="handleClick"
		class="flex justify-center items-center"
		style="height: 100%"
	>
		<vx-tooltip text="Technologies" placement="top">
			<feather-icon
				icon="CpuIcon"
				class="m-0 cursor-pointer"
				style="color: #08b0b9"
			/>
		</vx-tooltip>
	</div>
	<div v-else>-</div>
</template>
  
  <script>
import Vue from "vue";
import PropsectTechnologyPopup from "../ProspectTechnologyPopup.vue";
export default {
	props: {
		onePs: Object, // Pass the data object that contains the `id` and `url`
	},
	data() {
		return {
			onePs: {},
		};
	},
	created() {
		this.onePs = this.params.data;
	},
	components: {
		PropsectTechnologyPopup,
	},
	methods: {
		handleClick() {
			this.displayTechnologies(this.onePs.id, this.onePs.url);
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		displayTechnologies(pid, url) {
			let ComponentClass = Vue.extend(PropsectTechnologyPopup);
			let technologiesPopup = new ComponentClass({
				propsData: {
					popupActive: true,
					prsopect_id: pid,
					prospect_url: url,
				},
			});
			technologiesPopup.$mount();

			this.$refs.popupContainer.appendChild(technologiesPopup.$el);
		},
	},
};
</script>
  
  <style scoped>
/* Optional styling */
</style>